import { Component, Input, OnInit } from '@angular/core';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { IMAGES_RESOLUTIONS } from '../../utils/image-config/base/base/types';

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.scss']
})
export class DesignComponent implements OnInit {

  @Input() designData: any;
  IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
  ngOnInit(): void {
  }
}
